import {
  type RefObject,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  getVideoMuted,
  registerVideoPlayback,
  type VideoPlaybackController,
} from '../utils/videoPlayback';

export function useVideoPlayback(
  videoRef: RefObject<HTMLVideoElement | null>,
  enabled: boolean,
  source: string,
  preview = false,
) {
  const [muted, setMuted] = useState(getVideoMuted);
  const controller = useRef<VideoPlaybackController | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!enabled || !video) return;
    const playback = registerVideoPlayback(video, setMuted, preview);
    controller.current = playback;
    return () => {
      playback.dispose();
      controller.current = null;
    };
  }, [videoRef, enabled, source, preview]);

  const play = useCallback(() => controller.current?.play(), []);
  const pause = useCallback(() => controller.current?.pause(), []);
  const toggleMuted = useCallback(() => controller.current?.toggleMuted(), []);
  return { muted, play, pause, toggleMuted };
}
